import { render, staticRenderFns } from "./genomicsBBData.vue?vue&type=template&id=7ab98b22&scoped=true"
import script from "./genomicsBBData.vue?vue&type=script&lang=js"
export * from "./genomicsBBData.vue?vue&type=script&lang=js"
import style0 from "./genomicsBBData.vue?vue&type=style&index=0&id=7ab98b22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab98b22",
  null
  
)

export default component.exports